export default __webpack_public_path__ + "static/media/complementary--maximum-speed-limit-70--g1.361e8a6e.png";